import { ItemDefinition } from "./models/common";

let itemDefsPromise: Promise<ItemDefinition[]> | null = null;
export function fetchItemDefs(): Promise<ItemDefinition[]> {
  if (!itemDefsPromise) itemDefsPromise = fetch("/data/items.json").then((r) => r.json());
  return itemDefsPromise;
}

// Lets a failed fetch be retried instead of permanently caching a rejected promise.
export function resetItemDefsCache(): void {
  itemDefsPromise = null;
}
